<template>
  <div class="container text-left">
    <div class="row mt-4">
      <div class="col text-center">
        <h5>Glossary</h5>
        <div class="float-right">
          <button
            class="btn btn-link"
            data-toggle="modal"
            data-target="#createKeywordModal"
            v-on:click="keywordToEdit = null"
          >
            Add Keyword
          </button>
        </div>
      </div>
    </div>
    <div
      v-for="(keyword, index) in keywords.slice().sort($orderByName)"
      :key="keyword.Keyword_Id"
      class="row pt-2"
      v-bind:class="{ 'light-background': index % 2 === 1 }"
    >
      <div class="col-auto">
        <i
          class="material-icons d-block pointer mt-1"
          v-on:click="editKeyword(keyword)"
        >
          edit
        </i>
      </div>
      <div class="col">
        <p class="mb-1">
          <b>{{ keyword.Name }}</b>
        </p>
        <p style="white-space: pre-wrap;">
          {{ keyword.Definition }}
        </p>
      </div>
    </div>
    <CreateKeywordModal
      v-bind:KeywordToEdit="keywordToEdit"
      @editedKeyword="keywordEdited"
      @addedKeyword="keywordAdded"
      @deletedKeyword="keywordDeleted"
    />
  </div>
</template>

<script>
import CreateKeywordModal from "@/modals/Glossary/CreateKeywordModal.vue";
import $ from "jquery";

export default {
  name: "Home",
  data() {
    return {
      keywords: [],
      keywordToEdit: null
    };
  },
  components: {
    CreateKeywordModal
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    var view = this;
    try {
      view.$data.keywords = await view.$getKeywords();
      view.$store.commit("updateLoading", false);
    } catch (err) {
      console.log(err);
      view.$store.commit("updateLoading", false);
    }
  },
  methods: {
    editKeyword(keyword) {
      this.keywordToEdit = keyword;
      $("#createKeywordModal").modal("show");
    },
    keywordAdded(keyword) {
      this.keywords.push(keyword);
    },
    keywordEdited(editedKeyword) {
      var editingIndex = this.keywords.findIndex(
        o => o.Keyword_Id == editedKeyword.Keyword_Id
      );
      this.$set(this.keywords, editingIndex, editedKeyword);
    },
    keywordDeleted(keywordId) {
      var deletedIndex = this.keywords.findIndex(
        o => o.Keyword_Id == keywordId
      );
      this.keywords.splice(deletedIndex, 1);
    }
  }
};
</script>

<style></style>
